/* eslint-disable no-undef */
(function (window) {
    "use strict";
    function defineSettingsService() {
        let settingsService = {};
        settingsService.getOtpExpiry = function (){
            return axios.get("/api/SettingsService/GetOtpExpiry");
        };
        return settingsService;
    }
    //define globally if it doesn't already exist
    if (typeof (settingsService) === "undefined") {
        window.settingsService = defineSettingsService();
    } else {
        console.log("settingsService already defined.");
    }
})(window);